exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bot-table + div.text-center {\n  margin-top: 20px;\n}\n.truncate {\n  max-width: 50vw;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.bot-table .v-data-table-header {\n  background-color: #4472c4;\n}\n.bot-table .theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {\n  color: #fff;\n}\n.bot-table tbody tr:nth-child(odd) {\n  background-color: #d9e1f2;\n}\n.bot-table td:not(:last-child),\n.bot-table th:not(:last-child) {\n  border-right: 1px solid #ccc;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/stylus-loader!./node_modules/vue-loader/lib??vue-loader-options!./src/components/bot/table/bot.table.vue?vue&type=style&index=0&id=705356be&lang=stylus&
// module id = 725
// module chunks = 0 10